export default __webpack_public_path__ + "static/media/right.fd1209f2.svg";